import { lang } from 'src/utils';

export const KNOWN_USER = 'knownUser';
export const MOP_KNOWN_USER = 'mopKnownUser';

export enum KNOWN_USER_TYPES {
  knownUser = 'knownUser',
  mopKnownUser = 'mopKnownUser',
}
export const KnownUserTabs = [
  {
    label: lang.thankYouComponent.knownUser,
    value: KNOWN_USER,
  },
  {
    label: lang.thankYouComponent.mobileUser,
    value: MOP_KNOWN_USER,
  },
];
